import {Component, HostBinding, Input, OnInit, ViewChild} from '@angular/core';
import {FormGroup, NgForm} from '@angular/forms';
import {ReflexiveRestModel} from '../../reflexive-model/reflexive-rest-model';
import {FieldGroup} from '../../reflexive-model/field-group';
import {FieldDefinition} from '../../reflexive-model/field-definition';

@Component({
  selector: 'app-base-form',
  templateUrl: './base-form.component.html',
  styleUrls: ['./base-form.component.css']
})
export class BaseFormComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @HostBinding('class.form-container') true;
  @Input() formGroup: FormGroup;
  @Input() model: ReflexiveRestModel;
  @Input() formFieldNames: string[];
  @Input() modelFieldNames: string[];
  constructor() { }

  ngOnInit() {
  }

  showField(fieldName: string): boolean {
    return this.model.fields[fieldName] &&
      (!this.model.fields[fieldName].isVisible || this.model.fields[fieldName].isVisible.bind(this.model)(this.formGroup))
      && this.formFieldNames.indexOf(fieldName) !== -1;
  }

  showFieldGroup(fieldDefinition: FieldDefinition): boolean {
    switch (fieldDefinition.type) {
      case 'group':
        return fieldDefinition.groupContents.some(nestedFieldDefinition => this.showFieldGroup(nestedFieldDefinition));
      case 'field':
        return this.showField(fieldDefinition.name);
    }
  }
}
